import React from "react";
import { Image } from "semantic-ui-react";
import ImageCrop from "./ImageCrop";
import usePhoto from "@common/components/hooks/usePhoto";

const CustomerPhotoCrop = ({ size = 200 }) => {
  const { photo, toggleCropper, showCropper } = usePhoto();

  const image =
    photo ??
    "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP88B8AAuUB8e2ujYwAAAAASUVORK5CYII=";

  return (
    <>
      <Image
        onClick={() => photo && toggleCropper({ showCropper: true })}
        className={`${photo ? "clickable" : ""} border-grey-1`}
        style={{ height: `${size}px`, width: `${size}px`, objectFit: "cover" }}
        src={image}
      />
      {showCropper && <ImageCrop image={image} />}
    </>
  );
};

export default CustomerPhotoCrop;
